import type { SearchOption } from "@jsq/ds/core";
import { withClientContext } from "~/apollo/client";
import { useGetAssignableDdqProdOpsOperatorsQuery } from "~/graphql/supergraphHooks";

export type UseAssignableStaffSearchResult = {
  options: SearchOption[];
  isLoading: boolean;
};

// Backed by Main's admin role — no dedicated ProdOps role exists yet.
export const useAssignableStaffSearch = (search: string): UseAssignableStaffSearchResult => {
  const { data, loading } = useGetAssignableDdqProdOpsOperatorsQuery({
    variables: { search: search || undefined },
    context: withClientContext("federation"),
    fetchPolicy: "cache-and-network",
  });

  const options = (data?.assignableDdqProdOpsOperators ?? []).map((user) => ({
    id: user.id,
    label: user.fullName ?? "Unnamed user",
  }));

  return { options, isLoading: loading };
};
